export default __webpack_public_path__ + "84db5432a5764448d729b7d8452b4199.png";